import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { ListQuote, Quote } from "../../types/Quote";

type SetQuoteLockedPayload = {
  dossierId: string;
  quoteId: string;
  locked: boolean;
};

export const setQuoteLocked = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    optimisiticUpdateOnMutate,
    getDataByQueryKey,
  } = useAPQuery();

  return useMutation({
    mutationFn: (payload: SetQuoteLockedPayload): Promise<boolean> => {
      return fetchWithAuth<boolean>("setQuoteLocked", payload.quoteId, {
        requestOptions: { method: "post", body: JSON.stringify(payload) },
      });
    },
    onMutate: async (payload) => {
      // Update Quotes
      const quotesQueryKey = ["quotes", payload.dossierId];
      const quotes = getDataByQueryKey(quotesQueryKey) as ListQuote[];

      if (quotes) {
        const quoteIndex = quotes.findIndex(
          (quote) => quote.identifiers.crmQuoteId === payload.quoteId
        );
        const quoteToUpdate = quotes[quoteIndex];
        const updatedQuotes = [...quotes];
        updatedQuotes[quoteIndex] = {
          ...quoteToUpdate,
          config: {
            ...quoteToUpdate.config,
            isLocked: payload.locked,
          },
        };

        optimisiticUpdateOnMutate(quotesQueryKey, updatedQuotes);
      }

      // Update Quote
      const quoteQueryKey = ["quote", payload.quoteId];
      const quote = getDataByQueryKey(quoteQueryKey) as Quote;

      if (quote) {
        optimisiticUpdateOnMutate(quoteQueryKey, {
          ...quote,
          config: { ...quote.config, isLocked: payload.locked },
        });
      }
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
